var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-header",class:{
    '-mt-6': !_vm.noOverlap,
  }},[_c('div',{class:{
      'container shadow-md bg-white border-b-4 border-primary-200': !_vm.noOverlap,
    }},[(_vm.$slots.navigation)?_c('nav',{class:{
        'app-header-tabs -mb-1': !_vm.noOverlap,
        'flex justify-center app-header-links border-b border-grey-300': _vm.noOverlap,
      }},[_vm._t("navigation")],2):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }